(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tbo-fashiongo-band"] && !Shopify.designMode) return;
  try {
    
// FashionGo reviews: constant speed (px/s) whatever the number of cards; row 2 a little slower; pauses while hovered (CSS).
document.querySelectorAll('.tbo-fg-band .tn-rv').forEach(rv => {
  const tracks = rv.querySelectorAll('.tn-rv__track'); if (!tracks.length) return;
  const base = matchMedia('(max-width:799px)').matches ? 30 : 40; // ponytail: fixed px/s, make it a section setting if anyone asks
  const fit = () => tracks.forEach((t, i) => t.style.setProperty('--tn-rv-dur', Math.max(12, (t.scrollWidth / 2) / (i ? base * 0.77 : base)) + 's'));
  fit(); addEventListener('resize', fit, {passive: true});
});

  } catch(e) { console.error(e); }
})();
})();
